import { DxPopupModule, DxDataGridModule, DxProgressBarModule, DxScrollViewModule, DxTabsModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimulateMultiResultsPopUpComponent } from './simulate-multi-results-pop-up/simulate-multi-results-pop-up.component';



@NgModule({
	declarations: [SimulateMultiResultsPopUpComponent],
	imports: [
		CommonModule,

		DxPopupModule,
		DxDataGridModule,
		DxProgressBarModule,
		DxScrollViewModule,
		DxTabsModule,
	],
	exports: [SimulateMultiResultsPopUpComponent]
})
export class SimulateMultiResultsPopUpModule { }
